import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'fallback-options-dialog',
  templateUrl: './fallback-options.dialog.html',
  styleUrls: ['./fallback-options.dialog.scss'],
  standalone: false,
})
export class FallbackOptionsDialog implements OnInit {
  action: 'create' | 'edit';
  mode: 'on' | 'off';
  displayObj: {
    title: string;
    body: string;
    buttonText: string;
  };
  currency;
  rate = new UntypedFormControl('');
  name = new UntypedFormControl('Standard Shipping');
  @Output() onAction = new EventEmitter<{ mode: string; rate: any; name: string }>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FallbackOptionsDialog>,
  ) {}

  ngOnInit(): void {
    this.action = this.data.action;
    this.mode = this.data.mode;
    this.currency = this.data.currency;
    if (this.data.name) {
      this.name.setValue(this.data.name);
    }

    if (this.data.rate) {
      this.rate.setValue(this.data.rate);
    }

    this.initMode();
  }

  initMode(): void {
    if (this.action == 'create' && this.mode == 'on') {
      this.displayObj = {
        title: `Turn on fallback rate?`,
        body: `Once turned on, the fallback rate will only be available to orders where none
      of your delivery methods apply`,
        buttonText: `Turn on`,
      };
    } else if (this.action == 'create' && this.mode == 'off') {
      this.displayObj = {
        title: `Turn off fallback rate?`,
        body: `The fallback rate ensures customers ordering always have a shipping option available even if their order doesn’t match any of your delivery methods. Turning it off might stop some customers from checking out.`,
        buttonText: `Turn off`,
      };
    } else if (this.action == 'edit' && this.mode == 'on') {
      this.displayObj = {
        title: `Edit fallback rate?`,
        body: `Edit the fallback rate for orders.`,
        buttonText: `Save`,
      };
    }
  }

  onClick(event) {
    this.onAction.emit({ mode: event, rate: this.rate?.value, name: this.name?.value });
  }

  close(): void {
    this.dialogRef.close();
  }
}
